import {useState} from "react";
import {useRouter} from "next/router";
import localized from "../locale/locales";
import {getCookiePreferences} from "../helpers/cookies";

import MainLayout from "../components/layouts/MainLayout";
import ScheduleTrial from "../components/ScheduleTrial";

import SectionCardioZone from "../components/sections/SectionCardioZone";
import SectionFeatures from "../components/sections/SectionFeatures";
import SectionGymHeader from "../components/sections/SectionGymHeader";
import SectionSolution from "../components/sections/SectionSolution";
import SectionStrengthZone from "../components/sections/SectionStrengthZone";

import iconSkillrow from "../public/img/icons/skillrow.png";
import iconSkillmill from "../public/img/icons/skillmill.png";
import iconAirbike from "../public/img/icons/airbike.png";
import iconNetflix from "../public/img/icons/netflix.png";
import iconCharge from "../public/img/icons/charge.png";
import iconYoutube from "../public/img/icons/youtube.png";
import iconDumbbell from "../public/img/icons/dumbbell.png";
import iconTechnology from "../public/img/icons/technology.png";
import iconEleiko from "../public/img/icons/eleiko.png";
import {getInitialTrialSlots} from "../helpers/api/trial-slots";

const featureIconsCardio = [
    iconSkillrow,
    iconSkillmill,
    iconAirbike,
    iconNetflix,
    iconCharge,
    iconYoutube
];

const featureIconsStrength = [
    iconDumbbell,
    iconEleiko,
    iconTechnology,
];

export default function Gym({trialSlotsResponse, hasCookiePreferences, cookiePreferences}) {
    const {locale} = useRouter();
    const lang = localized[locale].gym;

    const [hiddenNav, setHiddenNav] = useState(false);

    return (
        <MainLayout hasCookiePreferences={hasCookiePreferences}
                    cookiePreferences={cookiePreferences}
                    footerTheme="dark"
                    title={lang.og.title}
                    description={lang.og.description}
                    hiddenNav={hiddenNav}
                    image={`https://nextmove.cz/img/og/${locale}_og-image_gym.png`}
        >
            <SectionGymHeader/>

            <SectionStrengthZone/>

            <SectionFeatures
                items={lang.featuresStrength}
                icons={featureIconsStrength}
                bodyColor="white"
                className="pt-24 md:pb-24"
            />

            <SectionCardioZone/>

            <SectionFeatures
                items={lang.featuresCardio}
                icons={featureIconsCardio}
                className="pt-24 md:pb-24"
            />

            <SectionSolution/>

            <ScheduleTrial
                initialSlots={trialSlotsResponse}
                setHiddenNav={setHiddenNav}
                className="py-16 md:py-24"
            />
        </MainLayout>
    )
}


export async function getServerSideProps({req, res}) {
    const cookiePreferences = getCookiePreferences(req);
    const trialSlots = await getInitialTrialSlots();

    return {
        props: {
            trialSlotsResponse: trialSlots,
            ...cookiePreferences
        }
    }
}
